import {useEffect, useState} from 'react';

/** hook that syncs a variable to local storage. Listens to "storage" event */
export const useLocalStorage = (
  key: string,
  defaultValue?: string,
): [
  string | undefined,
  React.Dispatch<React.SetStateAction<string | undefined>>,
] => {
  const [value, setValue] = useState<string | undefined>(
    localStorage.getItem(key) ?? defaultValue,
  );

  useEffect(() => {
    if (value === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
  }, [key, value]);

  useEffect(() => {
    const onChange = (event: StorageEvent) => {
      if (event.key !== key) {
        return;
      }
      setValue(event.newValue ?? undefined);
    };

    window.addEventListener('storage', onChange, false);
    return () => window.removeEventListener('storage', onChange);
  }, [key]);

  return [value, setValue];
};
